const screenSizes = {
  xxs: 0,
  smallMobile: 320,
  mobile: 480,
  tablet: 744,
  ultraTablet: 769,
  desktop: 1024,
  mediumDesktop: 1280,
  largeDesktop: 1440,
  hugeDesktop: 1666,
  ultraDesktop: 2550,
};

export const {
  xxs,
  smallMobile,
  mobile,
  tablet,
  ultraTablet,
  desktop,
  mediumDesktop,
  largeDesktop,
  hugeDesktop,
  ultraDesktop,
} = screenSizes;
